import { type FC } from "react";
import { Stack, Typography } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FormattedMessage } from "react-intl";

interface ShowMoreLessToggleProps {
	readonly isExpanded: boolean;
	readonly onToggle: () => void;
}

export const ShowMoreLessToggle: FC<ShowMoreLessToggleProps> = ({ isExpanded, onToggle }) => {
	return (
		<Stack
			direction="row"
			onClick={onToggle}
			sx={{
				cursor: "pointer",
				alignItems: "center",
				justifyContent: "center",
				padding: 1,
			}}
		>
			{isExpanded === true && (
				<>
					<ExpandLessIcon sx={{ fontSize: 24 }} color="info" />
					<Typography variant="overline" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
						<FormattedMessage id="Show less" defaultMessage="Show less" />
					</Typography>
					<ExpandLessIcon sx={{ fontSize: 24 }} color="info" />
				</>
			)}
			{isExpanded === false && (
				<>
					<ExpandMoreIcon sx={{ fontSize: 24 }} color="info" />
					<Typography variant="overline" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
						<FormattedMessage id="Show more" defaultMessage="Show more" />
					</Typography>
					<ExpandMoreIcon sx={{ fontSize: 24 }} color="info" />
				</>
			)}
		</Stack>
	);
};
